import AXIOS from '@/axios-instance';

export default {

  retrievePossiblePermissions() {
    return AXIOS.get("/permission");
  },
  updatePermission(role){
    return AXIOS.post("/permission", role)
  },
  retrievePossibleProcessPermissions() {
    return AXIOS.get("/permission/process");
  },
}